import React from 'react';

interface IEditProps {
	size?: string;
	fill?: string;
	id?: string;
}

export const Edit = ({ size = '24', fill, id = 'editIcon' }: IEditProps) => {
	return (
		<svg role="img" width={size} height={size} viewBox="0 0 24 24" fill="none" aria-labelledby={id}>
			<title id={id}>edit pencil icon</title>
			<path
				d="M9.61139 18.3967L4 20L5.60325 14.3886L15.1939 4.79794C15.7283 4.28061 16.4447 3.99406 17.1885 4.00009C17.9322 4.00613 18.6438 4.30428 19.1698 4.83022C19.6957 5.35617 19.9939 6.06777 19.9999 6.81154C20.0059 7.55532 19.7194 8.27166 19.2021 8.80608L9.61139 18.3967Z"
				stroke={fill || '#3D3D3D'}
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.9915 6.00043L17.9997 10.0086"
				stroke={fill || '#3D3D3D'}
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
